{
  "de": {
    "customer": {
      "actions": {
        "addCompany": "Organisation hinzufügen",
        "addCustomer": "Kunden hinzufügen",
        "addSecondaryContact": "Sekundären Kontakt hinzufügen",
        "add_email_address": "E-Mail-Adresse hinzufügen",
        "bulk_import": "Kunden importieren",
        "cancel": "Rückgängig machen",
        "changeProfilePicture": "Profilbild ändern",
        "createNewCustomer": "Neuen Kunden hinzufügen …",
        "goToCustomerProfile": "Zur Kontaktseite des Kunden gehen",
        "new": "Kunde",
        "profilePictureFormat": "Bild sollte mindestens <strong>300x300px</strong> groß sein",
        "removeCompany": "Organisationsdetails entfernen",
        "removeCustomer": "Zuweisung dieses Kunden aufheben",
        "removeSecondaryContact": "Sekundären Kontakt entfernen",
        "save": "Speichern",
        "searchCustomer": "Kunden suchen",
        "submit": "Speichern",
        "uploadProfilePicture": "Profilbild hochladen"
      },
      "attributes": {
        "address": "Adresse",
        "birth_date": "Geburtsdatum",
        "categories": {
          "enduser": "Eigennutzer",
          "investor": "Investor"
        },
        "category": "Kundentyp",
        "company_name": "Organisationsname",
        "company_vat": "USt-IdNr.",
        "email_address": "E-Mail",
        "email_address_secondary": "E-Mail sekundärer Kontakt",
        "email_notifications_interval": {
          "daily": "Einmal täglich (gegen Mittag)",
          "hourly": "Stündlich",
          "twice_daily": "Zweimal täglich (Mittag/Abend)",
          "weekly": "Einmal wöchentlich (montags mittags)"
        },
        "first_name": "Vorname",
        "iban": "IBAN",
        "internal_note": "Interne Notiz",
        "language": "Sprache",
        "last_name": "Nachname",
        "phone_landline": "Festnetznummer",
        "phone_mobile": "Mobilnummer",
        "status": "Status"
      },
      "import": {
        "fill_customer_info": "Vorlage mit Kundendaten ausfüllen",
        "fix_file_upload_customer": "Bitte beheben Sie die Probleme und laden Sie die Datei erneut hoch.</br>Bestehende Kunden werden nicht entfernt, aber aktualisiert, wenn sich seit dem letzten Upload etwas in der Datei für diesen Kunden geändert hat."
      },
      "labels": {
        "customerAddedState": "<b>Noch nicht eingeladen.</b> Eine Einladungs-E-Mail wird gesendet, sobald {name} Zugriff auf eine zugewiesene Einheit erhält.",
        "customerAddedStateNoEmailAddress": "<b>Keine bekannte E-Mail-Adresse.</b> Eine E-Mail-Adresse wird benötigt, um {name} Zugriff auf eine zugewiesene Einheit zu geben.",
        "display": "Anzeigen",
        "hasAccessToUnit": "Hat Online-Zugriff auf Einheit",
        "information": "Ihre Informationen",
        "noCustomersYet": "Noch keine Kunden auf der Plattform",
        "noEmailAddress": "Keine E-Mail-Adresse",
        "noProject": "Noch kein Projekt zugewiesen",
        "noUnits": "Noch keine Einheiten zugewiesen",
        "notSharedWithCustomer": "Für Kunden nicht sichtbar",
        "notificationDisclaimer": "Sobald neue Inhalte für Sie verfügbar sind, erhalten Sie eine Benachrichtigung. Wenn Sie diese Benachrichtigungen noch nicht auf der Plattform gelesen haben, werden sie gebündelt und per E-Mail versendet. Unten können Sie Benachrichtigungen zu bestimmten Themen deaktivieren und die Häufigkeit der E-Mails erhöhen oder verringern.",
        "onPlatform": "Auf der Plattform",
        "otherSettings": "Weitere Einstellungen",
        "password": "Passwort",
        "primaryContact": "Ihre Angaben",
        "project": "Projekt",
        "secondaryContact": "Sekundärer Kontakt",
        "sharedWithCustomer": "Für Kunden sichtbar",
        "sorting": "Sortierung",
        "units": "Einheiten",
        "viaEmail": "Per E-Mail"
      },
      "messages": {
        "integrationUpdateInformation": "Bitte kontaktieren Sie uns, wenn Sie bestimmte Informationen aktualisieren möchten.",
        "userlessProfileNotice": "Für dieses Profil ist keine E-Mail-Adresse hinterlegt."
      },
      "toasts": {
        "birthday": "Alles Gute zum Geburtstag, {first_name}!",
        "create": "Kunde hinzugefügt",
        "delete": "Kunde gelöscht",
        "update": "Kunde aktualisiert",
        "upload": "Alle Kunden erfolgreich importiert"
      },
      "validation": {
        "needFirstName": "Vorname erforderlich",
        "needFirstNameSecondary": "Vorname des sekundären Kontakts erforderlich",
        "needLastName": "Nachname erforderlich",
        "needLastNameSecondary": "Nachname des sekundären Kontakts erforderlich"
      }
    }
  }
}
